<!-- Start Copyright End -->
<div class="copyrights-area">
    <div class="row align-items-center">
        <div class="col-lg-6 col-sm-6 col-md-6">
            <p>© XploreADoor is Proudly Owned by <a target="_blank">XploreADoor</a></p>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 text-end">
            <p>Designed by <a target="_blank">Team XploreADoor</a></p>
            <!-- <p>Designed by ❤️ <a target="_blank">EnvyTheme</a></p> -->

        </div>
    </div>
</div>
<!-- End Copyright End -->